<template>
  <div class="vx-row">
    <div class="w-full vx-col">
      <vx-card  titleIcon="FilterIcon" ref="filterCard" title="Advanced Filters" class="mb-8 user-list-filters" :collapse-action="true">
        <div class="vx-row">
          <div class="w-full vx-col md:w-1/3 sm:w-1/2">
            <label class="text-sm opacity-100 text-bold">Name</label>
            <vs-input type="search"  placeholder="Search.." v-model="filters['name']" class="w-full mb-4 md:mb-0"/>
          </div>
        </div>
      </vx-card>
      <vx-card :title="'INDUSTRIAL SECTORS'" class="">
        <template slot="actions">
          <vs-button @click="onClickAdd" v-can="'edit-industrial-sector-setting'" icon-pack="feather" icon="icon-plus" class="mr-4"  color="primary" type="filled">create</vs-button>
        </template>
        <div id="industrial-sector-list-table" class="vx-row">
          <div class="w-full vx-col">

            <vs-table stripe sort class="mt-8" :data="industrial_sectors">
              <template slot="thead">
                <vs-th width="25%">Name</vs-th>
                <vs-th width="25%">Active Status</vs-th>
                <vs-th width="25%">Actions</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr class="cursor-pointer" :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td :data="data[indextr].name">
                    {{ data[indextr].name }}
                  </vs-td>
                  <vs-td :data="data[indextr].name">
                    {{ data[indextr].is_active === 1 ? 'active' : 'disabled' }}
                  </vs-td>
                  <vs-td :data="data[indextr].id">
                    <div class="justify-start vx-row" v-can="'edit-industrial-sector-setting'">
                      <vx-tooltip text="View/Update" position="left">
                        <vs-button @click.stop="onClickUpdate(data[indextr].id)"  class="ml-3"
                                 size="small" color="warning" type="border" icon-pack="feather" icon="icon-edit-2"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip text="Remove" position="left">
                        <vs-button @click.stop="openConfirm(data[indextr].id)" class="ml-3"
                                 size="small" color="danger" type="border" icon-pack="feather" icon="icon-trash-2"></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>

                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>

      </vx-card>
    </div>
    <create-industrial-sector-popup ref="CreateIndustrialSectorPopup"/>
    <update-industrial-sector-pop-up ref="UpdateIndustrialSectorPopup" />
  </div>
</template>

<script>
import {RepositoryFactory} from '@/repository/RepositoryFactory';
import Filter from '@/mixins/filter';
import CreateIndustrialSectorPopup from "@/components/popups/settings/industrial-sectors/CreateIndustrialSectorPopup";
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
import UpdateIndustrialSectorPopUp from "@/components/popups/settings/industrial-sectors/UpdateIndustrialSectorPopUp";

const IndustrialSectorsRepository = RepositoryFactory.get('industrial_sector')

export default {
  name: "IndustrialSectorsSettings",
  components: {UpdateIndustrialSectorPopUp, CreateIndustrialSectorPopup},
  data() {
    return {
      industrial_sectors:{},
      filters:{}
    }
  },
  mixins: [Filter,SuccessMessage,ErrorMessages],
  mounted() {
    this.fetchIndustrialSectors()
  },
  methods: {
    async refreshData(){
      await this.fetchIndustrialSectors()
    },
    async fetchIndustrialSectors(){
      await this.$vs.loading({
        container: '#industrial-sector-list-table',
        scale: 0.45
      })
      const {data} = await IndustrialSectorsRepository.getListOfIndustrialSectors(this.filterQuery)
      this.industrial_sectors = data.data
      this.$vs.loading.close('#industrial-sector-list-table > .con-vs-loading')
    },
    filterQueryUpdate (){
      this.fetchIndustrialSectors()
    },
    async onClickAdd() {
      await this.$refs.CreateIndustrialSectorPopup.openPopup()
    },
    openConfirm(id) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Confirm`,
        text: 'Are you sure you want to delete this ?',
        accept: this.onClickDelete,
        parameters: [id]
      })
    },
    async onClickDelete(params){
      await this.$vs.loading({
        container: '#industrial-sector-list-table',
        scale: 0.45
      })
      try {
        await IndustrialSectorsRepository.deleteIndustrialSector(params[0])
        this.showSuccessMessage('Industrial Sector deleted successfully');
        await this.fetchIndustrialSectors()
      } catch (error){
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#industrial-sector-list-table > .con-vs-loading')
    },
    async onClickUpdate(id){
      await this.$refs.UpdateIndustrialSectorPopup.openPopup(id)
    }
  }
}
</script>

<style scoped>

</style>
